import { put, takeLatest, select } from 'redux-saga/effects';

import { getIsMobile } from 'src/store/view/selectors';
import { logger } from 'src/error';

import {
  FETCH_TESTIMONIALS,
  TESTIMONIALS_PAGE_COUNT,
  TESTIMONIALS_MIN_RATING,
} from './constants';
import { loadTestimonialsSuccess, loadTestimonialsFail } from './actions';
import { getHotelCountryID } from '../../../../store/selectors/hotel';
import { api } from '../../../../../../api';

import { getTestimonialIds } from './selectors';

function* fetchTestimonials() {
  const countryId = yield select(getHotelCountryID);
  const loadedEntriesIds = yield select(getTestimonialIds);
  const options = {
    count: TESTIMONIALS_PAGE_COUNT,
    filter: { min_rating: TESTIMONIALS_MIN_RATING, country_id: countryId },
    exclude_ids: loadedEntriesIds,
    moderated: false,
  };
  const testimonialsData = yield api.getTestimonialsRandom(options);
  return testimonialsData;
}

function* fetchData() {
  try {
    const data = yield fetchTestimonials();
    const isMobile = yield select(getIsMobile);
    if (data) {
      yield put(loadTestimonialsSuccess({ data, append: isMobile }));
    } else {
      yield put(loadTestimonialsFail('error'));
    }
  } catch (error) {
    logger(error, 'Testimonials: Невозможно загрузить отзывы');
    yield put(loadTestimonialsFail(error));
  }
}

export default function* () {
  yield takeLatest(FETCH_TESTIMONIALS, fetchData);
}
